import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Table } from 'hljd'
import { toJS } from 'mobx'
import { getFuncVal, omit } from '@hlj/hlj-utils'
import defaultProps from './defaultProps'

/*
Tabled的columns中新增支持的属性有
hidden：是否隐藏
 */
@observer
export default class extends Component {
  static defaultProps = defaultProps

  componentWillUnmount() {
    this.props.store.$clearParams && this.props.store.$clearParams()
  }

  componentDidMount() {
    if (this.props.shouldGetListWhenDidMount) {
      this.props.store.$getList(1)
    }
  }

  getColumns = columns => {
    const _columns = []
    columns.forEach((item, i) => {
      const { hidden, editable, ...rest } = item

      if (!getFuncVal(hidden)) {
        rest.key = rest.dataIndex || 'COLUMN_KEY' + i
        _columns.push(rest)
      }
    })
    return _columns
  }

  render() {
    const {
      store: {
        $list,
        $loading,
        $pagination,
        $selectedRowKeys,
        $onSelectChange,
        $paging
      },
      rowSelection,
      selectabled,
      columns,
      rowKey,
      locale,
      ...rest
    } = this.props
    let _rowSelection = {
      selectedRowKeys: $selectedRowKeys,
      onChange: $onSelectChange
    }
    if (rowSelection) {
      _rowSelection = rowSelection
    }
    const _columns = this.getColumns(columns)

    return (
      <Table
        rowKey={rowKey}
        columns={_columns}
        dataSource={toJS($list)}
        loading={$loading}
        rowSelection={selectabled || rowSelection ? _rowSelection : null}
        onChange={$paging}
        pagination={$pagination}
        locale={locale}
        {...omit(rest, 'shouldGetListWhenDidMount')}
      />
    )
  }
}
